<div [formGroup]="formGroup" class="form-group">
    <label class="control-label col-form-label-sm" *ngIf="label !== ''">{{label}}</label>
    <textarea class="form-control form-control-sm {{additionalClass}} {{error ? 'is-invalid' : ''}}"
           [formControlName]="formControlNameValue"
           name="{{name}}" id="{{id}}"
           (ngModelChange)="change()"
              rows="5"
              [required]="required"> </textarea>
    <div class="invalid-feedback" [hidden]="!error">
        {{error | translate}}
    </div>
  </div>
